export const CourseType = Object.freeze({
  core: 'core',
  adviser: 'adviser',
  mastery: 'mastery',
});

export const CourseColor = Object.freeze({
  [CourseType.core]: 'green',
  [CourseType.adviser]: 'blue',
  [CourseType.mastery]: 'purple',
});

export const CourseCPDTime = Object.freeze({
  [CourseType.core]: '2 hours',
  [CourseType.adviser]: '3 hours',
  [CourseType.mastery]: '4 hours',
});
